import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const TokensReducer = (state = [], { type, payload }) => {
    switch (type) {
        case SteemActionType.LOAD_TOKENS:
            return payload;
        default:
            return state;
    }
};
export default TokensReducer;
